// find the highest percentage decrease between monthly and yearly prices of specified products
import {Product} from '../product';
import {findBestMonthlyPrice, findBestPrice, findBestYearlyPrice} from './find-best-price';
import {Fragment, memo} from 'react';
import {Trans} from '@ui/i18n/trans';

interface UpsellLabelProps {
  products?: Product[];
}
export const UpsellLabel = memo(({products}: UpsellLabelProps) => {
  const upsellPercentage = calcHighestUpsellPercentage(products);

  if (upsellPercentage <= 0) {
    return null;
  }

  return (
    <Fragment>
      <span className="font-medium text-positive-darker">
        {' '}
        (
        <Trans
          message="Save up to :percentage%"
          values={{percentage: upsellPercentage}}
        />
        )
      </span>
    </Fragment>
  );
});

function calcHighestUpsellPercentage(products?: Product[]) {
  if (!products?.length) return 0;

  const percentages = products.map(product => {
    if (product.hidden) return 0;

    const monthly = findBestMonthlyPrice(product.prices);
    const yearly = findBestYearlyPrice(product.prices);

    if (!monthly || !yearly) return 0;

    const monthlyAmount = monthly.amount * 12;
    const yearlyAmount = yearly.amount;

    const savingsPercentage = Math.round(
      ((monthlyAmount - yearlyAmount) / monthlyAmount) * 100,
    );

    return savingsPercentage > 0 && savingsPercentage <= 200
      ? savingsPercentage
      : 0;
  });

  return Math.max(...percentages, 0);
}
